import React from "react";
import StudiengangListBase from "./StudiengangListBase";

const ZertifikatsList: React.FC<{}> = () => {
  return <StudiengangListBase isZertifikat variables={{ where: { ausbildungsArtId: { eq: 2 } } }} />;
};

export default ZertifikatsList;
